<template>
  <div
    class="group flex cursor-pointer items-start rounded-md bg-white px-5 py-4 shadow-[0_4px_30px_0px_rgba(0,180,210,0.2)] hover:bg-blue-dark hover:text-white"
    :class="[modelValue === value ? '!bg-blue text-white' : ' text-blue']"
    @click="onClick"
  >
    <div class="radio-wrapper">
      <input
        type="radio"
        :checked="modelValue === value"
        :value="value"
        class="mt-[-8px] cursor-pointer !ring-[0px] group-hover:!border-blue-dark xl:mt-[-2px]"
      />
    </div>

    <div class="ml-5 flex flex-col transition-colors duration-500">
      <label
        class="cursor-pointer font-sans text-lg font-bold leading-5 group-hover:text-white xl:text-xl"
        :class="[modelValue === value ? 'font-bold text-white' : 'text-black']"
      >
        {{ label }}
      </label>
      <span
        v-if="description"
        class="mt-1 font-sans text-[15px] leading-6 group-hover:text-white"
        :class="[modelValue === value ? 'text-white' : 'text-black']"
      >
        {{ description }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  image: {
    type: String,
  },
  label: {
    type: String,
    default: '',
  },
  description: {
    type: String,
    default: '',
  },
  categories: {
    type: Object,
  },
  modelValue: {
    type: [String, Number],
    default: '',
  },
  value: {
    type: [String, Number],
    required: true,
  },
  tallCards: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['update:modelValue'])

const onClick = () => emit('update:modelValue', props.value)
</script>

<style scoped>
.radio-wrapper {
  --borderColor: #00b4d2;
  --borderWidth: 2px;
}

.radio-wrapper input[type='radio'] {
  -webkit-appearance: none;
  appearance: none;
  vertical-align: middle;
  background: #fff;
  border-radius: 100%;
  display: inline-block;
  border: var(--borderWidth) solid var(--borderColor);
  width: 24px;
  height: 24px;
  position: relative;
}

.radio-wrapper input[type='radio']:checked {
  border: white;
}

.radio-wrapper input[type='radio']:after {
  content: '';
  position: absolute;
  background: var(--borderColor);
  width: 7px;
  height: 3px;
  top: 14px;
  left: 30%;
  transform-origin: left center;
  border-radius: 4px;
}

.radio-wrapper input[type='radio']:checked:after {
  width: calc(var(--borderWidth) * 7);
  transform: rotate(-45deg) translateY(calc(var(--borderWidth) * 2)) scaleX(1);
  transition: transform 200ms ease-out 200ms;
}

.radio-wrapper input[type='radio']:before {
  content: '';
  position: absolute;
  background: var(--borderColor);
  width: 10px;
  height: 3px;
  top: 11px;
  left: 20%;
  transform-origin: left center;
  border-radius: 4px;
}
.radio-wrapper input[type='radio']:checked:before {
  transform: rotate(45deg) translate(calc(var(--borderWidth) / -2), calc(var(--borderWidth) / -2))
    scaleX(1);
  transition: transform 200ms ease-in;
}

.radio-wrapper input[type='radio']:before {
  transform: rotate(45deg) translate(calc(var(--borderWidth) / -2), calc(var(--borderWidth) / -2))
    scaleX(0);
  transition: transform 200ms ease-in 200ms;
}
.radio-wrapper input[type='radio']:after {
  width: calc(var(--borderWidth) * 4);
  transform: rotate(-45deg) translateY(calc(var(--borderWidth) * 2)) scaleX(0);
  transform-origin: left center;
  transition: transform 200ms ease-in;
}

.radio-wrapper input[type='radio']:focus {
  outline: none !important;
  box-shadow: none !important;
}
</style>
